import { ChangeDetectionStrategy, Component, ViewEncapsulation, Input } from '@angular/core';
import { FiWrapperTableAdditionalColumns } from '@fi-shared/fi-wrapper-table/fi-wrapper-table-additional-columns';
import { FiProfileSizes, IUserProfile } from '@fi-shared/profile-icon/profile-icon.component';
import { SharedActionsBaseService } from '@fi-shared/fi-shared-services/shared-actions-base.service';
import { isDefined } from '@fi-shared/utils';

@Component({
    selector: 'fi-checklist2-answer-created-by',
    template: `
        <ng-container matColumnDef="ChangedByUserName">
            <mat-header-cell *matHeaderCellDef mat-sort-header #headerCell>
                <fi-wrapper-table-custom-sort-icon
                    sortIconType="string"
                    [ariaSortAttribute]="headerCell._getAriaSortAttribute()"
                    headerLabel="common.reported_by"
                />
            </mat-header-cell>
            <mat-cell *matCellDef="let item" class="column-show-mobile" [class.fi-cell-center-aligned]="isCenterAlignedCell">
                @if (isAnswerDefined(item.ChangedByProfile)) {
                    <div
                        class="changed-by-profile-data-wrapper cursor-pointer"
                        (click)="openUserViewDialog(item.ChangedByProfile.Id)"
                    >
                        <fi-profile-icon
                            [profileData]="item.ChangedByProfile"
                            [size]="FiProfileSizes.Size32px"
                            [isRound]="true"
                        />
                        <fi-wrapper-table-span-cell class="BrandedColorHoverSmooth" [value]="item.ChangedByUserName" />
                    </div>
                    @if (isChangedOnDateShown) {
                        <div class="changed-on-data-wrapper">
                            <mat-icon class="far fa-clock" />
                            <fi-wrapper-table-changed-on-cell
                                [fiDateFormatRegistry]="fiDateFormatRegistry"
                                [value]="item"
                                [isChangedByDataShown]="false"
                            />
                        </div>
                    }
                }
            </mat-cell>
        </ng-container>
    `,
    styleUrls: ['./fi-checklist2-answer-created-by.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-checklist2-answer-value' },
    providers: [{ provide: FiWrapperTableAdditionalColumns, useExisting: FiChecklist2AnswerCreatedByComponent }],
    standalone: false,
})
export class FiChecklist2AnswerCreatedByComponent extends FiWrapperTableAdditionalColumns {
    @Input() isChangedOnDateShown: boolean;
    @Input() fiDateFormatRegistry: Intl.DateTimeFormatOptions;
    @Input() isCenterAlignedCell: boolean = false;

    protected readonly FiProfileSizes = FiProfileSizes;

    constructor(private sharedActionsService: SharedActionsBaseService) {
        super();
    }

    isAnswerDefined(changedByProfile: IUserProfile): boolean {
        return isDefined(changedByProfile) && !!changedByProfile?.Id;
    }

    openUserViewDialog(userId: number) {
        this.sharedActionsService.openUserViewPopup(userId);
    }
}
